type FlowProgressState = {
	setup?: FlowData['setup'] | null
	currentQuarter?: number | null
}

export function isFlowGameComplete(flow: FlowProgressState | null | undefined, numPeriods: number) {
	return !!flow?.setup && typeof flow.currentQuarter === 'number' && flow.currentQuarter > numPeriods
}
